/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { TrackingData } from './tracking-data';

/**
 * Summary information about an ASR job, to support identification and tracking.
 * @export
 * @interface JobInfo
 */
export interface JobInfo {
  /**
   * The UTC date time the job was created.
   * @type {string}
   * @memberof JobInfo
   */
  created_at: string;
  /**
   * Name of data file submitted for job.
   * @type {string}
   * @memberof JobInfo
   */
  data_name: string;
  /**
   * The data file audio duration (in seconds).
   * @type {number}
   * @memberof JobInfo
   */
  duration: number;
  /**
   * The unique id assigned to the job.
   * @type {string}
   * @memberof JobInfo
   */
  id: string;
  /**
   * Name of the text file submitted to be aligned to audio.
   * @type {string}
   * @memberof JobInfo
   */
  text_name?: string;
  /**
   *
   * @type {TrackingData}
   * @memberof JobInfo
   */
  tracking?: TrackingData;
}
